import React from "react";

// Page body was commented out pre-migration; keep a default export so Vite/Rollup can resolve the route.
const character = () => null;

export default character;
